import { Link } from "react-router-dom";
import { Server } from "lucide-react";

const Footer = () => (
  <footer className="bg-[#07090E] border-t border-slate-800/60" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-lg bg-cyan-500/20 border border-cyan-500/30 flex items-center justify-center">
              <Server className="text-cyan-400" size={20} />
            </div>
            <span className="font-bold text-lg text-white tracking-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              ServeurOnline
            </span>
          </div>
          <p className="text-slate-500 text-sm leading-relaxed max-w-xs">
            Plateforme de monitoring de sauvegardes pour les MSPs. Veeam, Iperius et plus encore.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Produit</h4>
          <div className="space-y-3">
            <Link to="/features" className="block text-slate-400 hover:text-cyan-400 text-sm transition-colors">Fonctionnalites</Link>
            <Link to="/pricing" className="block text-slate-400 hover:text-cyan-400 text-sm transition-colors">Tarifs</Link>
            <Link to="/contact" className="block text-slate-400 hover:text-cyan-400 text-sm transition-colors">Contact</Link>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Ressources</h4>
          <div className="space-y-3">
            <Link to="/login" className="block text-slate-400 hover:text-cyan-400 text-sm transition-colors">Connexion</Link>
            <Link to="/register" className="block text-slate-400 hover:text-cyan-400 text-sm transition-colors">Essai gratuit</Link>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Support</h4>
          <div className="space-y-3">
            <p className="text-slate-400 text-sm">contact@serveuronline.com</p>
            <p className="text-slate-400 text-sm">Lun - Ven, 9h - 18h</p>
          </div>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-slate-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-slate-600 text-xs">&copy; {new Date().getFullYear()} ServeurOnline. Tous droits reserves.</p>
        <div className="flex items-center gap-6">
          <Link to="/mentions-legales" className="text-slate-600 text-xs hover:text-slate-400 transition-colors">Mentions legales</Link>
          <Link to="/confidentialite" className="text-slate-600 text-xs hover:text-slate-400 transition-colors">Confidentialite</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
